__turbopack_context__.v({
  "chevronLeft": "lqU8qq_chevronLeft",
  "root": "lqU8qq_root",
  "stackedPreferences": "lqU8qq_stackedPreferences",
  "title": "lqU8qq_title",
});
